
// 生产
const configProduction = {
  baseUrl: 'https://api.ryere.cn', //后台地址
  baseLotteryUrl: 'https://api.ryere.cn',
  webUrl:'https://www.ryere.cn'
};

//dev
const configDev = {
  baseUrl: 'http://dev-api.ryere.cn', //后台地址
  baseLotteryUrl: 'https://dev-api.ryere.cn',
  webUrl:'https://test.ryere.cn'
};

//展示测试环境
const configUat = {
  baseUrl: 'https://dev-api.ryere.cn', //后台地址
  baseLotteryUrl: 'https://dev-api.ryere.cn',
  webUrl:'https://test.ryere.cn'
};
//演示环境
const configSit = {
  baseUrl: 'https://demo-api.ryere.cn',
  baseLotteryUrl: 'https://demo-api.ryere.cn',
   webUrl:'https://demo.ryere.cn'
};

const config = () => {
  if (process.env.NODE_ENV === 'production') {
    return configProduction;
  } else if (process.env.NODE_ENV === 'uat') {
    return configUat;
  }else if(process.env.NODE_ENV === 'sit'){
    return configSit;
  }
  return configDev;
};

export default config();



// WEBPACK FOOTER //
// ./src/lib/requestConf/config.js